/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgNeo4JLogoBlackBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 308 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M57.3779 21.5162C40.5967 21.5162 29.3328 31.411 29.3328 50.5135V64.0909C30.9412 63.2854 32.7812 62.8247 34.7344 62.8247C36.6877 62.8247 38.5277 63.2854 40.2519 64.0909V50.3977C40.2519 37.9707 47.0328 31.6426 57.3779 31.6426C67.7231 31.6426 74.504 37.9707 74.504 50.3977V80.2005H85.423V50.3977C85.5388 31.182 74.1592 21.5162 57.3779 21.5162Z"
      fill="#1A1B1D"
    />
    <path
      d="M91.4011 51.5481C91.4011 34.1724 104.044 21.4006 121.976 21.4006C139.908 21.4006 152.322 34.1724 152.322 51.5481V55.5755H103.01C104.618 65.8152 112.205 71.4535 122.089 71.4535C129.447 71.4535 134.619 69.1529 137.952 64.2042H150.021C145.654 74.9045 135.309 81.6931 122.089 81.6931C104.158 81.6931 91.3985 68.9213 91.3985 51.5456L91.4011 51.5481ZM140.942 45.794C138.757 36.5889 131.287 31.6402 122.092 31.6402C112.897 31.6402 105.54 36.7021 103.357 45.794H140.945H140.942Z"
      fill="#1A1B1D"
    />
    <path
      d="M158.3 51.5481C158.3 34.1724 170.943 21.4006 188.875 21.4006C206.806 21.4006 219.449 34.1724 219.449 51.5481C219.449 68.9238 206.806 81.6957 188.875 81.6957C170.943 81.6957 158.3 68.9238 158.3 51.5481ZM208.53 51.5481C208.53 39.9266 200.715 31.6427 188.99 31.6427C177.266 31.6427 169.45 39.9266 169.45 51.5481C169.45 63.1697 177.266 71.4535 188.99 71.4535C200.715 71.4535 208.53 63.1697 208.53 51.5481Z"
      fill="#1A1B1D"
    />
    <path
      d="M281.978 91.5929H283.242C290.254 91.5929 292.897 88.4869 292.897 80.3164V23.3589H303.816V79.6267C303.816 93.7809 298.299 101.03 284.276 101.03H281.978V91.5959V91.5929Z"
      fill="#1A1B1D"
    />
    <path
      d="M276.577 85.7229H265.655V72.1458H237.955C232.437 72.1458 227.61 69.3845 225.425 65.0122C223.356 60.869 223.93 56.0362 226.92 52.0088L251.862 19.2157C255.426 14.3828 261.517 12.427 267.15 14.267C272.897 16.107 276.577 21.2847 276.577 27.3837V62.4774H284.85V72.259H276.577V85.7209V85.7229ZM236.002 57.992C235.657 58.4526 235.541 59.0265 235.541 59.6029C235.541 61.0981 236.804 62.3642 238.3 62.3642H265.655V27.0389C265.655 25.1989 264.276 24.5067 263.702 24.3934C263.473 24.2776 263.128 24.2776 262.667 24.2776C261.978 24.2776 261.172 24.5067 260.483 25.4279L236.002 57.992Z"
      fill="#1A1B1D"
    />
    <path
      d="M298.404 0C293.232 0 289.094 4.2564 289.094 9.4367C289.094 14.617 293.348 18.8709 298.404 18.8709C303.461 18.8709 307.715 14.6144 307.715 9.4367C307.715 4.259 303.461 0 298.404 0Z"
      fill="#1A1B1D"
    />
    <path
      d="M4.73608 54.312C3.35676 55.0017 2.09321 56.152 1.17192 57.6497C0.253212 59.1449 -0.0916182 60.7558 0.0216118 62.3668C0.137412 65.2439 1.7458 67.8893 4.38868 69.3845C6.80258 70.7638 9.56128 70.419 12.2042 69.8451C15.4235 69.0396 18.1822 68.6948 21.0542 70.4216H21.17C26.1135 73.2986 26.1135 80.548 21.17 83.4225H21.0542C18.1797 85.1489 15.421 84.8039 12.2042 83.9989C9.67448 83.3092 6.91578 82.9644 4.38868 84.4599C1.7458 85.9549 0.250642 88.7159 0.0216118 91.4769C-0.0941982 93.0879 0.250642 94.6989 1.17192 96.1939C2.09063 97.6899 3.24095 98.8399 4.73608 99.5319C7.26578 100.798 10.3693 100.798 13.0122 99.3029C15.4261 97.9239 16.5764 95.2759 17.2661 92.7429C18.1848 89.5219 19.2193 86.9889 22.2096 85.3779C25.0841 83.6515 27.8428 83.9989 31.0596 84.8039C33.5893 85.4939 36.348 85.8389 38.8751 84.3439C41.518 82.8486 43.0131 80.0873 43.2422 77.326V76.1757C43.1264 73.2986 41.518 70.6532 38.8751 69.158C36.4612 67.7761 33.7025 68.1235 31.0596 68.6974C27.8403 69.5029 25.0816 69.8477 22.2096 68.1209C19.3351 66.3942 18.1874 63.9777 17.2661 60.7558C16.5764 58.2236 15.4261 55.6939 13.0122 54.1962C10.3693 53.0459 7.26578 53.0459 4.73608 54.312Z"
      fill="#1A1B1D"
    />
  </svg>
);
const SvgNeo4JLogoBlack = wrapIcon(SvgNeo4JLogoBlackBase);
export default SvgNeo4JLogoBlack;
